import { render } from "./BaseDialog.vue?vue&type=template&id=8fc403fa&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=ts"
export * from "./BaseDialog.vue?vue&type=script&lang=ts"

import "./BaseDialog.vue?vue&type=style&index=0&id=8fc403fa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8fc403fa"

export default script